import { render, staticRenderFns } from "./ModalProduct.vue?vue&type=template&id=8ab38f8c&"
import script from "./ModalProduct.vue?vue&type=script&lang=js&"
export * from "./ModalProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports